import React from "react";

function CoreLayout(props) {
    return <div>{props.children}</div>;
}

export default CoreLayout;
